
import { Link } from 'react-router-dom';

import { Typography, Box } from '@mui/material';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

type Params = {
    title: string;
    link: string;
}

const NavSubPage = ({ title, link }: Params) => {
    return (
        <Box sx={{
            display: 'flex',
            gap: '.4375rem',
            alignItems: 'flex-end',
            marginBottom: '1.64rem',
            paddingBottom: '.56rem',
            borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
        }}>
            <Link to={link}>
                <Box sx={{
                    width: '1.5rem',
                    height: '1.5rem',
                    borderRadius: '2px',
                    display: 'flex',
                    padding: '.15rem 0',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #0C1C33',
                    'svg': {
                        fill: '#0C1C33'
                    }
                }}>
                    <ArrowBackIosNewIcon sx={{
                        height: '100%'
                    }} />
                </Box>
            </Link>
            <Typography fontSize='1.25rem' fontWeight={700} color='primary.main' lineHeight='1'>
                {title}
            </Typography>
        </Box>
    );
}

export default NavSubPage;